import { Modal } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import CustomButton from "../../shared/CustomButton2";
import { deleteSpecifications } from "../../Services/Specifications";
import { useParams } from "react-router-dom";

const DeleteSpecificationModal = ({ open, setOpen, idToDelete }) => {
  const handleClose = () => setOpen(false);
  const { id } = useParams();
  const client = useQueryClient();

  const { mutate: deleteSpecificationMutation } = useMutation(
    deleteSpecifications,
    {
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.message);
          client.invalidateQueries(`specifications-${id}`);
          handleClose();
        } else {
          toast.error(res?.data?.message);
        }
      },
    }
  );

  const handleDelete = () => {
    deleteSpecificationMutation({
      specification_ids: [idToDelete],
    });
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="absolute w-1/4 -translate-x-1/2 -translate-y-1/2 bg-white rounded-md top-1/2 left-1/2">
        <div className="relative flex flex-col gap-4 p-4">
          <Close
            className="absolute cursor-pointer right-4 top-4"
            onClick={handleClose}
          />
          <div className="w-4/5 mx-auto text-xl font-semibold text-center">
            Are you sure you want to delete this specification?
          </div>
          <div className="flex justify-center gap-4">
            <CustomButton
              variant="outlined"
              className="flex flex-grow !text-gray-700"
              onClick={handleClose}
            >
              Cancel
            </CustomButton>
            <CustomButton
              variant="outlined"
              className="flex flex-grow !text-red-600 !border-red-600"
              onClick={handleDelete}
            >
              Confirm
            </CustomButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteSpecificationModal;
